import { CustomPropertyOption, QuestionScope } from "../types";

export const resolveMatchingCustomProperty = ({
  body,
  scope,
  properties,
}: {
  body: string;
  scope: QuestionScope;
  properties: CustomPropertyOption[];
}): CustomPropertyOption | null => {
  const normalizedBody = body.trim().toLowerCase();
  if (!normalizedBody) {
    return null;
  }

  return (
    properties.find(
      (property) => property.body.trim().toLowerCase() === normalizedBody && !property.scopesOnForm.includes(scope)
    ) ?? null
  );
};
